<template>
  <RCard class="meta-data-tab q-pa-lg">
    <CustomMetaData :entity-id="id" entity-name="publisher" />
  </RCard>
</template>

<script>
// Components
import CustomMetaData from '@/reusable/custom-meta-data/CustomMetaData'

export default {
  components: {
    CustomMetaData
  },

  props: {
    id: [Number, String] // from route
  }
}
</script>
